import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
    } catch (error) {
      console.error("Settings load error:", error);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};
